module.exports = __webpack_public_path__ + "img/couples-039.0282c457.jpg";